<template>
<!-- 活动-组队活动-组队列表 -->
    <div class="container">
        <div class="handle-box-search">
            <el-row class="handle-box">
                <el-col :span="24">
                    <span class="title">客户手机号 : </span>

                    <!-- 搜索活动名称-->
                    <el-input
                        v-model="search_data.consumer_phone"
                        placeholder="请输入客户手机号"
                        class="handle-input mr10"
                        @keyup.enter.native="searchGroupActivityRecordLists"
                    ></el-input>
                </el-col>
            </el-row>
            <el-button type="primary" icon="el-icon-search" @click="searchGroupActivityRecordLists">搜索</el-button>

            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
        </div>

        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="name" label="活动名称"> </el-table-column>

            <el-table-column prop="consumer_phone" label="客户手机号"> </el-table-column>

            <el-table-column prop="time.YmdHis" label="开始时间"> </el-table-column>

            <el-table-column prop="end_time" label="结束时间"> </el-table-column>

            <el-table-column prop="num" label="组队人数"> </el-table-column>

            <el-table-column prop="type.alias" label="状态"> </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>
    </div>
</template>

<script>
var _this;
export default {
    data() {
        return {
            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                consumer_phone: ''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.groupActivityRecordLists();
    },

    methods: {
        searchGroupActivityRecordLists() {
            _this.search_data.page = 1;
            _this.groupActivityRecordLists();
        },
        // 搜索司机日志列表
        groupActivityRecordLists() {
            _this
                .$post('/groupactivity/GroupActivityRecordLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;

                    _this.result_data = res;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.groupActivityRecordLists();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-form-item.el-form-item--small {
    width: 100%;
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
}

.el-form-item__content span {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
}
</style>
